import PostIndexDesktop from "./PostIndexDesktop";
import PostIndexMobile from "./PostIndexMobile";

export interface PostIndexProps {
  indexList: string[];
}

function PostIndex({ indexList }: PostIndexProps) {
  return (
    <>
      <PostIndexMobile indexList={indexList} />
      <PostIndexDesktop indexList={indexList} />
    </>
  );
}

export default PostIndex;
